import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SaveExportXmpMetadataToCompositionMutationVariables = Types.Exact<{
  compositionId: Types.Scalars['ID']['input'];
  xmpMetadata: Types.CompositionXmpMetadataInput;
}>;


export type SaveExportXmpMetadataToCompositionMutation = { __typename?: 'Mutation', saveExportXmpMetadataToComposition?: { __typename?: 'AfterEffectsComposition', id?: string | null, metadata: Array<{ __typename?: 'CompositionExportsXMPMetadata', assetId: string, compositionId?: string | null, compositionName?: string | null, versionId?: string | null, projectId: string, accountId: string, exportedAt: number, workAreaStart?: number | null, workAreaDuration?: number | null }> } | null };


export const SaveExportXmpMetadataToComposition = /*#__PURE__*/ gql`
    mutation SaveExportXmpMetadataToComposition($compositionId: ID!, $xmpMetadata: CompositionXMPMetadataInput!) {
  saveExportXmpMetadataToComposition(
    compositionId: $compositionId
    xmpMetadata: $xmpMetadata
  ) {
    id
    metadata {
      assetId
      compositionId
      compositionName
      versionId
      projectId
      accountId
      exportedAt
      workAreaStart
      workAreaDuration
    }
  }
}
    ` as unknown as DocumentNode<SaveExportXmpMetadataToCompositionMutation, SaveExportXmpMetadataToCompositionMutationVariables>;

          

          export const useSaveExportXmpMetadataToCompositionMutation = (options?:MutationHookOptions<SaveExportXmpMetadataToCompositionMutation, SaveExportXmpMetadataToCompositionMutationVariables>) => useMutation(SaveExportXmpMetadataToComposition, options);
          

          export type SaveExportXmpMetadataToCompositionMutationOptions = MutationHookOptions<SaveExportXmpMetadataToCompositionMutation, SaveExportXmpMetadataToCompositionMutationVariables>;

          

          export type SaveExportXmpMetadataToCompositionMutationResult = ReturnType<typeof useSaveExportXmpMetadataToCompositionMutation>[1];

          
